module.exports = __webpack_public_path__ + "img/about-default.2f6e844f.svg";